<template>
  <div class="current-rides container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div style="display: flex; flex-direction: column;">

      <div class="row page-titles">
        <div class="col-md-5 align-self-center">
          <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
            <li class="breadcrumb-item active">{{ title }}</li>
          </ol>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
      <div>
        <div class="">
          <form v-on:submit.prevent>
            <div class="col-md-4 col-lg-4 p-0">
              <div class="m-3">
                <label class="search-label">Select a Ride Status</label>
                <select type="text" placeholder="Status"
                        class="form-control ddown" id="status-filter" v-model="selected_status" @change="checkStatus($event)">
                  <option v-bind:value=null>
                    All
                  </option>
                  <option v-for="(index, item) in data.filters.status" v-bind:value="index">
                    {{item.replace(item.charAt(0), item.charAt(0).toUpperCase()).replace("_", " ").replace("_", " ").replace("linear", "General").replace("logarithmic", "Accelerated")}}
                  </option>
                </select>
              </div>
            </div>
            <table class="table table-sm table-hover" data-sort-name="Date">
              <thead>
                <tr>
                  <th>
                    Page Size
                  </th>
                  <th>
                    <select v-model="perPage" class="form-control table-select" @change="checkPageSize($event)">
                      <option v-for="size in page_sizes">
                        {{size}}
                      </option>
                    </select>
                  </th>
                </tr>
                <br>
                <tr>
                  <th class="result-label">
                    <select class="form-control table-select" @change="checkSelection($event)" onfocus="this.selectedIndex = 0">
                      <option selected="selected">
                        Select
                      </option>
                      <option>
                        All
                      </option>
                      <option>
                        None
                      </option>
                    </select>
                  </th>
                  <th class="result-label" style="min-width: 100px;" v-for="column in data.resultColumns">
                    <div>
                      {{column}}
                      <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="col-12">
              <tr class="ride-item text-xs-center" v-for="ride in data.rides" >
                <!--<td class="result-item" v-for="item in ride">-->
                <!--{{ item }}-->
                <!--</td>-->
                <!-- Checkbox -->
                <td class="result-item text-center" width="80px">
                  <input type='checkbox' v-bind:value='ride' v-model='data.pool' v-bind:id="ride.id_ride">
                  <label class="search-label" v-bind:for="ride.id_ride" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                </td>
                <td class="result-item">
                  <router-link :to="'/rides/' + ride.id_ride + '/'">
                    <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                    {{ ride.id_ride }}
                  </router-link>
                </td>
                <td class="result-item">
                  <router-link :to="'/rides/' + ride.id_ride + '/'">
                    <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                    {{ ride.id_alternate ? ride.id_alternate : 'N/A' }}
                  </router-link>
                </td>
                <td>
                  {{ ride.id_market.name }}
                </td>
                <td>
                  {{ ride.deadhead ? "deadhead" : "regular" }}
                </td>
                <td>
                  {{ ride.id_type_ride_status.name }}
                </td>
                <td>
                  {{ ride.claim.name ? ride.claim.name : "N/A" }}
                </td>
                <td v-if="ride.id_driver">
                  <router-link :to="'/drivers/' + ride.id_driver.id_user + '/'">
                    <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                    {{ ride.id_driver && ride.id_driver.id_user ? (ride.id_driver.name_first + ' ' + ride.id_driver.name_last) : 'N/A' }}
                  </router-link>
                </td>
                <td v-else>
                  N/A
                </td>
                <td>
                  {{ ride.date_pickup_local ? moment.utc(ride.date_pickup_local).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_pickup).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') }}
                </td>
              </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
          <div style="margin: 1rem 1rem; float: left;">
            <span v-if="totalRows > 0">Showing {{ Number(perPage) * (currentPage-1) + 1 }} to {{ Number(perPage) * currentPage > totalRows ? totalRows : Number(perPage) * currentPage }} of {{ totalRows }} entries</span>
            <span v-else>Showing 0 entries</span>
          </div>
          <div style="margin: 0 1rem; float: right;">
            <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=Number(perPage) :limit=limit @change="changePage">
            </b-pagination>
          </div>
        </div>
      </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row assign-ride-actions" style="margin: 25px 0;">
        <div class="submit-button">
          <button v-on:click="showStatusUpdateModal = true; selected_distribution = 'completed'" class="btn btn-info waves-effect waves-light m-t-10" >Complete</button>
        </div>
        <div class="submit-button">
          <button v-on:click="showStatusUpdateModal = true; selected_distribution = 'payment_pending'" class="btn btn-info waves-effect waves-light m-t-10" >Payment Pending</button>
        </div>
        <div class="submit-button">
          <button v-on:click="showStatusUpdateModal = true; selected_distribution = 'paid_denied'" class="btn btn-info waves-effect waves-light m-t-10" >Paid Denied</button>
        </div>
        <div class="submit-button">
          <button v-on:click="showSendBackModal = true; selected_distribution = 'cancel'" class="btn btn-info waves-effect waves-light m-t-10" >Cancel</button>
        </div>
      </div>

    </div>

    <!-- Payment pending confirmation popup alert -->
    <div>
      <div v-if="this.data.pool.length > 0">
        <modal v-if="showStatusUpdateModal" @close="showStatusUpdateModal = false">
          <h3 slot="header">Update to {{titleCase(this.selected_distribution)}}</h3>
          <h5 slot="body">Please confirm updating the status for these rides to {{titleCase(this.selected_distribution)}}</h5>
          <div slot="footer">
            <button style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showStatusUpdateModal = false;">
              Back
            </button>
            <button id="paymentPendingTrue" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showStatusUpdateModal = false; distribute($event)">
              Confirm
            </button>
          </div>
        </modal>
      </div>
      <div v-else>
        <modal v-if="showStatusUpdateModal" @close="showStatusUpdateModal = false">
          <h3 slot="header">Update to {{titleCase(this.selected_distribution)}}</h3>
          <h5 slot="body">Please select at least one ride</h5>
          <div slot="footer" >
            <button style="width: 60px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showStatusUpdateModal = false">
              Ok
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Send-back confirmation popup alert -->
    <div id="sendBackConfirmation">
      <div v-if="this.data.pool.length > 0">
        <modal v-if="showSendBackModal" @close="showSendBackModal = false">
          <h3 slot="header">Confirm Ride Send-Back</h3>
          <h5 slot="body">Should this cancellation status be sent to SouthEasTrans?</h5>
          <div slot="footer" >
            <button id="cancelTrue" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showSendBackModal = false; distribute($event);">
              Yes
            </button>
            <button id="cancelFalse" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showSendBackModal = false; distribute($event);">
              No
            </button>
            <button style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showSendBackModal = false;">
              Back
            </button>
          </div>
        </modal>
      </div>
      <div v-else>
        <modal v-if="showSendBackModal" @close="showSendBackModal = false">
          <h3 slot="header">Cancel Ride</h3>
          <h5 slot="body">Please select at least one ride</h5>
          <div slot="footer" >
            <button style="width: 60px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showSendBackModal = false">
              Ok
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Error popup alert -->
    <div id="showErrorModal">
      <!-- use the modal component, pass in the prop -->
      <modal v-if="showErrorModal" @close="showErrorModal = false">
        <h3 slot="header">Error</h3>
        <h5 slot="body">No rides selected</h5>
      </modal>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Pending Payments',
    },
    name: "PendingPayments",
    data () {
      return {
        title: 'Pending Payments',
        currentPage: 0,
        currentMessage: null,
        totalRows: 0,
        showStatusUpdateModal: false,
        showErrorModal: false,
        showSendBackModal: false,
        selected_status: null,
        selected_distribution: null,
        page_sizes: [20, 50, 100, 500, 1000],
        data: {
          rides: [],
          resultColumns: ["Ride ID", "Leg ID", "Market", "Ride Type", "Ride Status", "Claims Status", "Driver", "Pick-up Date"],
          sortDirection: 0,
          pool: [],
          filters: {
            status: {
              "paid_denied": 24,
              "payment_pending": 26,
            }
          },
        },
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 20,
        errors: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      getPendingPayments: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'rides/?type=pending'
            + (this.selected_status == null ? '' : '&id_type_ride_status=' + this.selected_status)
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage))
          .then(response => {
            this.totalRows = response.data.count
            this.data.rides = response.data.results
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      distribute: function(event) {
        var sendBack = false
        if (event.target.id == "cancelTrue") {
          sendBack = true
        }
        var params = this.selected_distribution == "cancel" ? { sendBack: sendBack } : {}
        this.isLoading = true
        for (let i = 0; i < this.data.pool.length; i++) {
          let cur = this.data.pool[i]
          this.$http
            .patch(process.env.API_BASE_URL_CS + 'rides/' + this.data.pool[i].id_ride + "/?type=" + this.selected_distribution, params)
            .then(response => {
            })
            .catch(error => {
              this.check403(error);
              if (error.response.status == 401) {
                console.warn("redirect to login")
                this.handle401()
              }
              Vue.toasted.show('Unable to distribute!', {
                theme: 'bubble',
                position: this.toastPosition,
                duration: 2000
              })
              console.log(error.response)
              this.errors = error.response.data
              this.non_field_errors = error.response.data.non_field_errors
            })
            .finally(() => {
              this.data.pool = []
              this.getPendingPayments()
            })
          }
      },
      checkStatus: function(event) {
        this.getPendingPayments()
      },
      checkSelection: function(event) {
        this.data.isCheckAll = event.srcElement.selectedIndex == 1 ? false : true
        this.checkAll()
      },
      checkAll: function() {
        this.data.isCheckAll = !this.data.isCheckAll
        this.data.pool = []
        if(this.data.isCheckAll){ // Check all
          for (var key in this.data.rides) {
            this.data.pool.push(this.data.rides[key])
          }
        }
      },
      titleCase: function(str) {
        var splitStr = str.replace(/_/g, " ").toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
      },
      checkPageSize: function(event) {
        this.getPendingPayments()
      },
      changePage: function (page) {
        this.getPendingPayments(page)
      },
    },
    mounted () {
      this.getPendingPayments()
    },
    created () {
      // document.title = "Wingz Support | Current Rides";
    }
  }
</script>

<style scoped>
  .assign-ride-actions {
    display: block;
    text-align: right;
  }
  .assign-ride-actions .submit-button {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/PendingPayments.vue